import multiguard from 'vue-router-multiguard';
import AuthLayout from '@/layouts/AuthLayout';
import MainLayout from '@/layouts/MainLayout';
import LoginView from '@/views/LoginView';
import ClaveUnicaView from '@/views/ClaveUnicaView';
import UserListView from '@/views/UserListView';
import UserDetailsView from '@/views/UserDetailsView';
import UserImport from '@/views/UserImport';
import OrganizationListView from '@/views/OrganizationListView';
import OrganizationDetailsView from '@/views/OrganizationDetailsView';
import auth from '@/router/middlewares/auth';
import userType from '@/router/middlewares/user-type';
import guest from '@/router/middlewares/guest';

export default {
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: MainLayout,
      beforeEnter: multiguard([auth]),
      children: [
        {
          path: '/',
          redirect: 'dispensers'
        },
        {
          path: 'medical-centers',
          name: 'medical-centers',
          beforeEnter: multiguard([userType('admin')]),
          component: UserListView,
          props: { type: 'medical_center', title: 'Generadores de Folios' }
        },
        {
          path: 'dispensers',
          name: 'dispensers',
          beforeEnter: multiguard([userType('admin|dispenser_admin')]),
          component: UserListView,
          props: { type: 'dispenser', title: 'Auxiliares de Farmacia' }
        },
        {
          path: 'dispensers-admin',
          name: 'dispensers-admin',
          beforeEnter: multiguard([userType('admin|dispenser_admin')]),
          component: UserListView,
          props: { type: 'dispenser_admin', title: 'Químico farmacéuticos' }
        },
        {
          path: 'import-users',
          name: 'import-users',
          beforeEnter: multiguard([userType('admin')]),
          component: UserImport,
          props: { type: 'dispenser_admin', title: 'Importación masiva de usuarios (QF)' }
        },
        {
          path: 'organizations',
          name: 'organizations',
          beforeEnter: multiguard([userType('admin|dispenser_admin')]),
          component: OrganizationListView,
          props: { type: 'admin', title: 'Mantenedor de Organizaciones' }
        },
        {
          path: 'organizations/medical-centers',
          name: 'organizations-medical-centers',
          beforeEnter: multiguard([userType('admin')]),
          component: OrganizationListView,
          props: { type: 'admin', source: 'medical_center', title: 'Mantenedor de Centros Médicos' }
        },
        {
          path: 'organizations/pharmacies',
          name: 'organizations-pharmacies',
          beforeEnter: multiguard([userType('admin|dispenser_admin')]),
          component: OrganizationListView,
          props: { type: 'admin', source: 'midas', 'list-only': true, title: 'Listado de Farmacias' }
        },
        {
          path: 'organizations/:type/:organization_uuid',
          name: 'organizations-details',
          beforeEnter: multiguard([userType('admin|dispenser_admin')]),
          component: OrganizationDetailsView
        },
        {
          path: 'admin',
          name: 'admin',
          beforeEnter: multiguard([userType('admin')]),
          component: UserListView,
          props: { type: 'admin', title: 'Usuarios Minsal' }
        },
        {
          path: 'users/:id',
          name: 'user-details',
          component: UserDetailsView
        }
      ]
    },
    {
      path: '/auth',
      component: AuthLayout,
      children: [
        {
          path: 'login',
          name: 'login',
          component: LoginView,
          beforeEnter: multiguard([guest])
        },
        {
          path: 'claveunica',
          name: 'claveunica',
          props: { action: 'login' },
          beforeEnter: multiguard([guest]),
          component: ClaveUnicaView
        },
        {
          path: 'logout',
          name: 'logout',
          props: { action: 'logout' },
          beforeEnter: multiguard([auth]),
          component: ClaveUnicaView
        }
      ]
    }
  ]
};
